import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./banner-other-merchants.module.css";
import { BannerAds, Definitions } from "./banner-other-merchants.types";
import { getAdsStore } from "~/modules/ads-suggestions/components/banner-other-merchants/ads.service";
import { camelizeKeys } from "humps";
import { useOutletContext } from "@remix-run/react";

const BannerOtherMerchants = () => {
  const { t } = useTranslation();
  const { storeMetadata } = useOutletContext<any>();
  const storeIsPrime = false;
  const [adsBanner, setAdsBanner] = React.useState<BannerAds[]>([]);

  useEffect(() => {
    if (storeMetadata?.country) {
      getAdsStore(storeMetadata?.country).
      then(async (res) => {
        return (camelizeKeys(await res.json()) as BannerAds[]);
      }).
      then((res) => {
        setAdsBanner(res);
      });
    }
  }, []);

  return !storeIsPrime && !!adsBanner?.length ?
  <div className={styles.bannerOtherMerchantsWrapper}>
      {adsBanner?.map((item: BannerAds) =>
    <div
      className={
      item.definitions.length === 2 ?
      styles.doubleAds :
      item.definitions.length === 3 ?
      styles.tripleAds :
      styles.defaultAds}>


          {item.definitions.map((img: Definitions) =>
      <a
        className={styles.imageMerchant}
        href={img.callToAction}
        target='_blank'
        rel='noreferrer'>

              <p className={styles.adsText}>{t("ads.tex_banner")}</p>
              {img.urlBanner &&
        <img
          className={styles.imgBanner}
          src={img.urlBanner}
          alt='ads' />}


              {img.urlBannerMobile &&
        <img
          className={styles.imgBannerMobile}
          src={img.urlBannerMobile}
          alt='ads' />}


            </a>
      )}
        </div>
    )}
    </div> :
  null;
};
export default BannerOtherMerchants;